export default __webpack_public_path__ + "static/atle-b7e64c34a9fff1914641c2d983bd83c5.png";